<template>
  <div class="customer-check-in-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "customerCheckInBase",
};
</script>
